// extracted by mini-css-extract-plugin
module.exports = {"onDemandClassesContainer":"style-module__onDemandClassesContainer___29X2b"};